<mat-tab-group
  [preserveContent]="true"
  [mat-stretch-tabs]="false"
  (selectedIndexChange)="onSelectedIndexChange($event)"
  color="warn"
  class="tab-group"
  libTabActivated
>
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon [svgIcon]="EsvgFiles.money"/>
    </ng-template>

    <ng-template matTabContent>
      <app-evaluate-invoices/>
    </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon [svgIcon]="EsvgFiles.car"/>
    </ng-template>

    <ng-template matTabContent>
      <app-evaluate-transports/>
    </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon [svgIcon]="EsvgFiles.download"/>
    </ng-template>

    <ng-template matTabContent>
      <app-evaluate-carts/>
    </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon [svgIcon]="EsvgFiles.database"/>
    </ng-template>

    <ng-template matTabContent>
      <app-booking-record-export/>
    </ng-template>
  </mat-tab>
</mat-tab-group>
